import { NotificationMessages } from "./constants";

const getErrorData = (error) => {
    if (error.response.data["non_field_errors"]) {
        return {
            status: false,
            code: error.response.status,
            message: error.response.data["non_field_errors"][0],
        };
    }

    if (error.response.data && error.response.data !== "") {
        return {
            status: false,
            code: error.response.status,
            message: error.response.data,
        };
    }

    return null;
};

export const handleError = (error) => {
    if (error?.message === "canceled") {
        return {
            status: false,
            code: "ERR_CANCELED",
            message: "canceled",
        };
    }

    if (error?.message === "timeout") {
        return {
            status: false,
            code: null,
            message: "timeout",
        };
    }

    if (error?.response) {
        if (error.response.status === 400) {
            const errorData = getErrorData(error);
            if (errorData) {
                return errorData;
            }

            return {
                status: false,
                code: error.response.status,
                message: "Bad request",
            };
        }

        if (error.response.status === 401) {
            const errorData = getErrorData(error);
            if (errorData) {
                return errorData;
            }

            return {
                status: false,
                code: error.response.status,
                message: "Forbidden",
            };
        }

        if (error.response.status === 403) {
            const errorData = getErrorData(error);
            if (errorData) {
                return errorData;
            }

            return {
                status: false,
                code: error.response.status,
                message: "Unauthorized",
            };
        }

        if (error.response.status === 404) {
            return {
                status: false,
                code: error.response.status,
                message: "Not found",
            };
        }

        if (error.response.status === 409) {
            return {
                status: false,
                code: error.response.status,
                message: "Conflict",
            };
        }
    }

    return {
        status: false,
        code: null,
        message: NotificationMessages.genericErrorMessage,
    };
};
